import type { FilterVariables, Tournament } from '../../types/MTT';

export const filterVariables: FilterVariables = {
  games: [
    'HOLDEM',
    'HOLDEM',
    'HOLDEM',
    'SIX_PLUS_HOLDEM',
    'TEMPEST_HOLDEM',
    'SHOWTIME_HOLDEM',
    'SWAP_HOLDEM',
    'SPLIT_HOLDEM',
    'DEEPWATER_HOLDEM'
  ],
  structures: ['FIXED_LIMIT', 'NO_LIMIT', 'POT_LIMIT'],
  total: {
    minimum: 2000,
    maximum: 9900
  },
  seats: [7, 8, 9, 10],
  speeds: ['TURBO', 'HYPER'],
  channels: ['FEATURED']
};

export const tournaments = [
  {
    id: 1,
    fee: 105,
    buyIn: 2095,
    seats: 8,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: '',
    legacyStatus: 384
  },
  {
    id: 2,
    fee: 157,
    buyIn: 1700,
    seats: 8,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 384
  },
  {
    id: 3,
    fee: 262,
    buyIn: 5238,
    seats: 8,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'SLOW',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 0
  },
  {
    id: 4,
    fee: 262,
    buyIn: 5238,
    seats: 2,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'HYPER',
    tournSpeedInt: 3,
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1154
  },
  {
    id: 5,
    fee: 210,
    buyIn: 4190,
    seats: 8,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'HYPER',
    tournSpeedInt: 3,
    game: 'OMAHA',
    structure: 'NO_LIMIT',
    legacyStatus: 1154
  },
  {
    id: 6,
    fee: 210,
    buyIn: 4190,
    seats: 8,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1154
  },
  {
    id: 7,
    fee: 129,
    buyIn: 2571,
    seats: 8,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 384
  },
  {
    id: 8,
    fee: 129,
    buyIn: 2571,
    seats: 8,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1154
  },
  {
    id: 9,
    fee: 200,
    buyIn: 2000,
    seats: 9,
    channels: ['STREAM50', 'REGULAR', 'ALL'],
    tournSpeed: 'TURBO',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1154
  },
  {
    id: 10,
    fee: 300,
    buyIn: 3000,
    seats: 9,
    channels: ['STREAM50', 'REGULAR', 'ALL'],
    tournSpeed: 'TURBO',
    tournSpeedInt: 2,
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1154
  },
  {
    id: 11,
    fee: 300,
    buyIn: 3000,
    seats: 9,
    channels: ['STREAM50', 'REGULAR', 'ALL'],
    tournSpeed: 'TURBO',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 0
  },
  {
    id: 12,
    fee: 500,
    buyIn: 5000,
    seats: 8,
    channels: ['STREAM50', 'ALL', 'SATELLITES'],
    tournSpeed: 'TURBO',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 384
  },
  {
    id: 13,
    fee: 390,
    buyIn: 7810,
    seats: 8,
    channels: ['STREAM50', 'ALL', 'SATELLITES'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 384
  },
  {
    id: 14,
    fee: 157,
    buyIn: 3143,
    seats: 8,
    channels: ['STREAM50', 'ALL', 'SATELLITES'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1154
  },
  {
    id: 15,
    fee: 105,
    buyIn: 2095,
    seats: 8,
    channels: ['STREAM50', 'ALL', 'SATELLITES'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 0
  },
  {
    id: 16,
    fee: 105,
    buyIn: 2095,
    seats: 8,
    channels: ['STREAM50', 'ALL', 'SATELLITES'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1539
  },
  {
    id: 17,
    fee: 105,
    buyIn: 2095,
    seats: 8,
    channels: ['STREAM50', 'ALL', 'SATELLITES'],
    tournSpeed: 'HYPER',
    game: 'HOLDEM',
    structure: 'NO_LIMIT',
    legacyStatus: 1541
  }
] as Tournament[];

export const filteredTournaments = [
  {
    id: 6,
    buyIn: 4190,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    fee: 210,
    game: 'HOLDEM',
    seats: 8,
    structure: 'NO_LIMIT',
    tournSpeed: 'HYPER',
    legacyStatus: 1154
  },
  {
    id: 7,
    buyIn: 2571,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    fee: 129,
    game: 'HOLDEM',
    seats: 8,
    structure: 'NO_LIMIT',
    tournSpeed: 'HYPER',
    legacyStatus: 384
  },
  {
    id: 8,
    buyIn: 2571,
    channels: ['STREAM50', 'REGULAR', 'FEATURED', 'ALL'],
    fee: 129,
    game: 'HOLDEM',
    seats: 8,
    structure: 'NO_LIMIT',
    tournSpeed: 'HYPER',
    legacyStatus: 1154
  }
] as Tournament[];
